<template>
    <v-container fluid tag="section">
        <material-card color="primary" icon="mdi-watermark">
            <template #title v-if="id">
                <Відгук>: <b>{{ review.name }} #{{ id }}</b> <br>
            </template>
            <template #title v-else>
                Новий відгук
            </template>
            <v-row class="pl-3 pr-3">
                <v-col cols="12" sm="6">
                    <ButtonComeBack />
                </v-col>

                <!--Зберегти: "механіка" + "опис-->
                <v-col cols="12" sm="6" class="text-right">
                    <v-btn color="primary" min-width="150" @click="updateReview()">
                        Зберегти
                    </v-btn>
                </v-col>
            </v-row>

            <!-- {{ review }} -->
            <v-row>
                <v-col cols="12" lg="6">
                    <v-form class="form-reviews-edit" lazy-validation v-model="isValidForm" ref="formreviews">
                        <!-- ID -->
                        <v-col cols="12" v-if="review.id">
                            <v-text-field label="ID" v-model="review.id" readonly />
                        </v-col>
                        <!-- Проєкт -->
                        <v-col cols="12">
                            <v-select v-model="review.project_id" label="Проекти" cache-items item-text="name"
                                item-value="id" :items="projectList" required :rules="[v => !!v > 0 || errorRequired]"
                                prepend-icon="mdi-format-list-bulleted-type">
                            </v-select>
                        </v-col>
                        <v-col cols="12" v-if="review.ctime">
                            <v-text-field label="Додано" v-model="review.ctime" readonly />
                        </v-col>
                        <v-col cols="12">
                            <v-select v-model="review.status" label="Статус" required
                                :rules="[v => !!v || errorRequired]" prepend-icon="mdi-information-outline" :items="[
                                    { value: 'moderation', text: 'На модерації' },
                                    { value: 'published', text: 'Опубліковано' },
                                    { value: 'rejected', text: 'Відхилено' },
                                ]">
                            </v-select>
                        </v-col>
                        <v-col cols="12" v-if="review.change_time && review.change_time != review.ctime">
                            <v-text-field label="Дата модерації" v-model="review.change_time" readonly />
                        </v-col>
                        <v-col cols="12">
                            <v-autocomplete color="purple" no-filter hide-no-data return-object auto-select-first
                                no-data-text="Нічого не знайдено." label="Товар" :rules="[v => !!v || errorRequired]"
                                v-model="review.typhoon_id" :items="typhoonList" :search-input.sync="searchTyphoon"
                                :readonly="!(isAdmin || isManager)">
                            </v-autocomplete>
                        </v-col>
                        <v-col cols="12">
                            <v-text-field v-model="review.name" label="Ім'я автору" required
                                :rules="[v => !!v || errorRequired]" prepend-icon="mdi-account-outline">
                            </v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <v-text-field v-model="review.phone" label="Телефон" prepend-icon="mdi-phone-outline">
                            </v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <v-select v-model="review.rating" label="Оцінка" required
                                :rules="[v => !!v || errorRequired]" prepend-icon="mdi-star-outline" :items="[
                                    { value: '1', text: '1' },
                                    { value: '2', text: '2' },
                                    { value: '3', text: '3' },
                                    { value: '4', text: '4' },
                                    { value: '5', text: '5' },
                                ]">
                            </v-select>
                        </v-col>
                        <v-col cols="12">
                            <v-textarea v-model="review.review" label="Відгук" required
                                :rules="[v => !!v || errorRequired]" prepend-icon="mdi-comment-text-outline" rows="5">
                            </v-textarea>
                        </v-col>

                        <!-- Изображение -->
                        <v-col cols="12">
                            Дозволені формати зображень: jpg, jpeg, png. Максимальний розмір одного зображення 5 Мб.
                            <br>
                            <v-file-input small-chips multiple label="Зображення" v-model="images"
                                prepend-icon="mdi-image-multiple" show-size counter
                                accept="image/png, image/jpeg" :rules="[files => !files || files.every(f => f.size < 5242880) || 'Максимальний розмір одного зображення 5 Мб.']"
                                @change="onFileChange"></v-file-input>
                        </v-col>
                        <v-col cols="12" v-if="imagesList.length">
                            <v-row>
                                <v-col cols="6" sm="4" md="3" lg="2" v-for="(img, index) in imagesList" :key="index">
                                    <v-img :src="imageBaseUrl + img.image" aspect-ratio="1" @click="reviewImage = img.image; openImageDialog = true"
                                        class="grey lighten-2 position-relative">
                                        <template #placeholder>
                                            <v-row class="fill-height ma-0" align="center" justify="center">
                                                <v-progress-circular indeterminate
                                                    color="grey lighten-5"></v-progress-circular>
                                            </v-row>
                                        </template>

                                        <v-btn icon small color="red" class="close-btn" title="Видалити"
                                            @click.stop="deleteImage(img.id)">
                                            <v-icon>mdi-close</v-icon>
                                        </v-btn>
                                    </v-img>
                                </v-col>
                            </v-row>
                        </v-col>
                        <!-- Popup для просмотра зображення -->
                        <v-dialog v-model="openImageDialog" max-width="1600px">
                            <v-card>
                                <v-img :src="imageBaseUrl + reviewImage" aspect-ratio="1.7778"  contain>
                                    <template #placeholder>
                                        <v-row class="fill-height ma-0" align="center" justify="center">
                                            <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                                        </v-row>
                                    </template>
                                </v-img>
                            </v-card>
                        </v-dialog>



                        <Preloader v-if="isSending" />
                        <DialogConfitmDelete ref="dialogConfirmDelete" />
                    </v-form>
                </v-col>
            </v-row>
        </material-card>
    </v-container>
</template>


<script>
import { HTTP } from '@/http-common';
import { mapGetters, mapMutations, mapActions } from 'vuex';
import { IMAGE_BASE_URL } from '@/env.config';

export default {
    name: 'PageReviewsProfile',
    props: {
        id: {
            type: Number,
            default: null,
        }
    },
    data() {
        return {
            enabled: false,
            review: {
                id: null,
                project_id: null,
                status: 'moderation',
                typhoon_id: null,
                review: '',
                name: '',
                rating: '5',
                phone: '',
            },
            // Нужно vuetify для валидации формы
            isValidForm: true,
            // Сообщение об ошибке для обязательных полей
            errorRequired: `Це поле обов'язкове`,
            // Указывает на то что выполняется отправка формы
            isSending: false,
            reviewImage: null,//'/assets/img/reviews/2v9aj5numrmm1g710skx3wmy0wt3m5sp.png',
            // Базовый url картинки
            imageBaseUrl: `${IMAGE_BASE_URL}reviews/`,
            projectList: [],
            itemsPerPage: 50,
            openPropsDialog: false,
            isLoading: false,
            typhoonList: [],
            searchTyphoon: '',
            images: [],
            imagesList: [],
            openImageDialog: false,
        }
    },
    computed: {
        ...mapGetters(['snackbar', 'localization', 'isManager', 'isAdmin']),
    },
    async mounted() {
        await this.init();
    },
    watch: {
        searchTyphoon(val) {
            if (val && val.length >= 2) {
                this.searchGoods();
            } else {
                this.typhoonList = [];
            }
        }
    },
    methods: {
        ...mapMutations(['setSnackbar']),
        ...mapActions(['getLocalization']),
        async init() {
            await this.getLocalization();
            await this.getProjectList();
            if (this.id) {
                await this.getReview();
            }
        },
        async searchGoods() {
            try {
                let { data } = await HTTP.post('/search-goods', {
                    query: this.searchTyphoon,
                });
                this.typhoonList = data.content;
            } catch (error) {
                console.warn(error);
            }
        },
        async getReview() {
            try {
                this.isLoading = true;
                let { data } = await HTTP.post('/get-review', { 'id': this.$route.params.id });
                this.review = data.content;
                this.typhoonList = [{ value: data.content.typhoon_id ? String(data.content.typhoon_id) : null, text: data.content.product_name ? data.content.product_name : 'Товар відсутній' }];
                this.$set(this.review, 'typhoon_id', { value: data.content.typhoon_id ? String(data.content.typhoon_id) : null, text: data.content.product_name ? data.content.product_name : 'Товар відсутній' });
                this.imagesList = await this.getReviewsImagesFromApi(this.review);
                return data.content;
            } catch (error) {
                console.warn(error);
            } finally {
                this.isLoading = false;
            }
        },
        onFileChange(file) {
            this.images = file;
        },
        async updateReview() {
            let queryParams = this.review;

            if (this.isSending) return;
            if (!this.$refs.formreviews.validate()) {
                this.setSnackbar({ type: 'error', text: 'Форма заповнена не вірно' });
                return;
            }


            this.isSending = true;

            try {
                const { data } = await HTTP.post(this.review.id ? '/update-review' : '/create-review', { ...queryParams, typhoon_id: this.review.typhoon_id?.value || null });
                if (data.error) throw new Error(data.error);
                this.isSending = false;
                // Если есть изображения, то отправляем их на сервер
                if (this.images.length) {
                    this.setSnackbar({ type: 'info', text: 'Виконується завантаження зображень.' });
                    // відправляєм на сервер усі зображення по одночасно
                    let formData = new FormData();
                    this.images.forEach(image => {
                        formData.append('images', image, image.name);
                    });
                    formData.append('review_id', data.content.insertId || this.review.id);
                    try {
                        let response = await HTTP.post('/upload-review-images', formData);
                        if (response.data.error) {
                            this.setSnackbar({ type: 'error', text: `Помилка при завантаженні зображення: ${response.data.error}` });
                        }
                    } catch (error) {
                        this.setSnackbar({ type: 'error', text: `Помилка при завантаженні зображення: ${error?.response?.data?.message || error}` });
                    }
                    this.images = [];
                }
                if (data.content?.insertId && !this.review.id) {
                    this.$router.push(`/reviews/${data.content.insertId}`);
                } else {
                    // Обновляем данные отзыва
                    await this.getReview();
                }
                this.isSending = false;

                this.setSnackbar({
                    type: 'success',
                    text: `Данні оновлено. ${this.images.length ? 'Виконується завантаження зображень.' : ''}`
                });

            } catch (error) {
                console.warn(error);
                this.setSnackbar({ type: 'error', text: error?.response?.data?.message || 'Помилка сервера!' });
                this.isSending = false;
            }
        },
        async getReviewsImagesFromApi(item) {
            this.isSending = true;
            try {
                let { data } = await HTTP.post('/get-review-images', { review_id: item.id });
                return data.content
            } catch (e) {
                this.setSnackbar({ color: 'error', text: e.message || e });
                return [];
            } finally {
                this.isSending = false;
            }
        },
        async deleteImage(imageId) {
            let isConfirmDelete = await this.$refs.dialogConfirmDelete.callDialog();
            if (!isConfirmDelete) return;
            this.isSending = true;

            try {
                await HTTP.post('/delete-review-image', { id: imageId });
                this.imagesList = this.imagesList.filter(img => img.id !== imageId);
                this.setSnackbar({ color: 'success', text: 'Зображення видалено' });
            } catch (e) {
                this.setSnackbar({ color: 'error', text: e.message || e });
            } finally {
                this.isSending = false;
            }
        },

        // Получить список проектов
        async getProjectList() {
            try {
                let { data } = await HTTP.post('/get-projects');
                this.projectList = data.content;
            } catch (error) {
                console.warn(error);
            }
        },

    },
}
</script>

<style scoped lang="sass">
.form-reviews-edit
    .close-btn
        position: absolute
        top: 5px
        right: 5px
        background: rgba(255, 255, 255, 0.5)
        &:hover
            background: rgba(255, 255, 255, 1)
  </style>
